import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error boundary caught:", error, info);
  }

  reset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex items-center justify-center p-6 bg-[#F8FAFC]"
          data-testid="app-error-boundary"
        >
          <div className="max-w-md text-center bg-white border border-slate-200 rounded-xl p-8">
            <h2 className="font-heading text-xl font-semibold text-slate-900">Something went wrong</h2>
            <p className="text-slate-500 text-sm mt-2">
              An unexpected error occurred. Try again — your data is safe.
            </p>
            <button
              onClick={() => {
                this.reset();
                window.location.reload();
              }}
              className="mt-6 inline-flex items-center bg-slate-900 hover:bg-slate-700 text-white text-sm rounded-lg px-4 py-2 transition-colors"
              data-testid="app-error-reload"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
